/* File: detail.js
 ------------------
 This file does calculations and api calls for detail.html template.
 Important assumptions are noted here for reference.
 * Weight field in template is assumed that
  1 - it would be only 8 char long only.
  2 - it would not be null
  3 - 8th char should not be zero.

  if all 3 conditions are met then only weight element will be shown on consumer app. This validation is
  not done at the backoffice app.
*/

import { Component } from 'src/utils';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './product-detail.html';

@Component({
  controllerAs: 'productsDetail',
  template
})

export default class ProductsDetail {
  static $inject = [
      '$rootScope',
    '$scope',
    '$ngRedux',
    '$state',
    '$stateParams',
    'authService',
    'orderService',
    'orderActions',
    'spinnerService',
    'toaster',
    '$uibModal',
    '$timeout',
    '$window', 'APP'
  ];

  constructor($rootScope,$scope, $ngRedux, $state, $stateParams, $auth,
    $order, orderActions, $spinner, toaster, $uibModal, $timeout, $window, APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = $auth;
    this.$order = $order;
    this.toaster = toaster;
    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$uibModal = $uibModal;
   
    this.$window = $window;
    this.APP = APP;
   

    this.selectedItem = {};
    this.isItemAdded = false;
    this.guestCart = this.$auth.getGuestCart();
    var isLoggedIn = this.$auth.isLoggedIn();
    // console.log(isLoggedIn);
    this.checkForGuestCart();
    $rootScope.$on('onLoginSuccess', () => {
      this.checkForGuestCart();
  });

    $ngRedux.dispatch(orderActions.setProductDetail({}));
    $spinner.show('appSpinner');
    $order.getProducts("1")
      .then(success => {
        let productAvailable = success.data.filter(product => {
          let idArray = product.itemList.filter(item => item.masterProduct.id === parseInt($stateParams.subsProductId));
          return idArray.length ? true : false;
        }).length;
        //  console.log('success data', success.data);
        //  console.log('productAvailable', productAvailable);
        //  console.log('paramid', $stateParams.productId);
        if (success.data[0] === null) {
          this.productNotFound = true;
         // this.toaster.pop('success', 'You are trying to access wrong Sub-Category.');
         // this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
        }
        if (!productAvailable) {
          this.productNotFound = true;
         // this.toaster.pop('success', 'Product is not available');
         // this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
        }
        if ($stateParams.productId) {
          let productDetail = success.data.filter(item => {
            return item.itemList.filter(itemVariety =>
              itemVariety.id === parseInt($stateParams.productId))[0];
          })[0];

          let largestWeight = 0;
          let largestWeightItem = productDetail.itemList[0];
          if (largestWeightItem.weight) {
            for (var i = 0; i < productDetail.itemList.length; i++) {
              if (productDetail.itemList[i].weight > largestWeight) {
                largestWeightItem = productDetail.itemList[i];
                largestWeight = productDetail.itemList[i].weight;
              }
            }
          }
          if (!productDetail) {
            this.productNotFound = true;
           // this.toaster.pop('success', 'You are trying to access wrong Product Details.');
           //  this.$state.go('category', {'storeName': this.$auth.getGuestStoreDetail().storeName });
            return;
          }
          this.selectedItem = largestWeightItem;
          $ngRedux.dispatch(orderActions.setProductDetail(productDetail));
        }
      })
      .finally(() => $spinner.hide('appSpinner'));
      this.currencyType = 'USD';
      $timeout(() => {
      this.country = this.profile.store.country.countryCode?this.profile.store.country.countryCode:'US';
      
        if(this.profile.store){
          // console.log(this.profile);
          this.currencyType=$order.getCurrencyType(this.country);
        }
      },800);
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      detail: state.order.productDetail
    };
  }

  addItemToCart(form) {

    if (form.$invalid) {
      return;
    }
    if (this.$auth.isGuestLogin()) {
      let cart = null;
      cart = {'quantity': this.quantity, 'itemId': this.selectedItem.id, 'categoryId': this.$stateParams.categoryId, 'subCategoryId': this.$stateParams.subCategoryId ,'masterProductId':this.selectedItem.masterProduct.id};
      this.$auth.addtoGuestCart(cart);
      var $ctrl = this;
      var $state = this.$state;
      this.$uibModal.open({
        size: 'sm',
        template: '<div class="modal-body p-1-1 login_redirect_modal" id="modal-body" >You have to login/register to  add this item to cart<hr>' +
      '<h6><b><center>Do you want to continue?</center></b></h6>' +
      '</div>' +
      '<div class="modal-footer login_redirect_modal login_redirect_modal_footer bg-color bo-tp-o" >' +
      '<button class="btn btn-primary m-l-1" type="button" ng-click="cancel()" >Cancel</button>' +
      '<button class="btn btn-primary m-l-1" type="button" ng-click="ok()" ">OK</button>' +
      '</div>',
        controller: ['$scope', '$uibModalInstance', 'authService',
        function($scope, $uibModalInstance, $auth,$cookies) {
          $scope.ok = () => {
            $state.go('login', {'storeName': $auth.getGuestStoreDetail().storeName});
            $uibModalInstance.close();
          };
          $scope.cancel = () => {
            try {
              sessionStorage.removeItem('guestCart');
            }
            catch (e) {
              $cookies.remove('guestCart');
            }
            $uibModalInstance.close();
          };
        }
      ],
        resolve: {
          id: function() {
            return $ctrl.id;
          }
        }
      });
    }
    else {
      this.addToCart(this.quantity, this.selectedItem.id);
    }
  }
  addToCart(quantity, itemId) {
    this.disableAddToCart = true;

    this.$order.addItemToCart(quantity, itemId)
        .then(
            () => {
              this.isItemAdded = true;
              this.toaster.pop('success', 'Item added to cart');
              this.$auth.getUserProfile();
            },
    () => this.toaster.pop('success', 'Item already exists in cart. Click on cart icon on top right.')
  )
  .finally(() => {
    this.disableAddToCart = false;
    if (this.guestCart) {
      this.$auth.doGuestLogout();
    }
  }
  );
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  buyNow(form) {
    if (form.$invalid) {
      return;
    }
    this.$order.addItemToCart(this.quantity, this.selectedItem.id)
      .finally(() => this.$state.go('cart'));
  }

  selectWeight(item) {
    this.selectedItem = item;
    this.isItemAdded = false;
  }

  isDscMember() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }

  masterCodeChecker(item) {
    return item.masterProduct.masterCode &&
      (item.masterProduct.masterCode.length === 8 || item.masterProduct.masterCode.length === 9) &&
      item.masterProduct.masterCode[7] !== '0' &&
      item.weight !== null;
  }
  checkForGuestCart() {
    if (this.guestCart && this.$auth.isLoggedIn()) {
      this.addToCart(this.guestCart.quantity, this.guestCart.itemId);
    }
  }
    
  goToCart() {
    if (this.$auth.isGuestLogin()) {
      this.$state.go('guestcart', {'storeName': this.storeName});
    } else {
      this.$state.go('cart');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/order/subscription/product-detail.js